import { SectionTitle } from "components/sectionTitle";
import SocialStyleWrapper from "./SocialProfile.style";
import data from "assets/data/social/dataV1";
import { useTranslation } from "react-i18next";

const Social = () => {
  const { t } = useTranslation();
  return (
    <SocialStyleWrapper>
      <div className="container">
        <SectionTitle isCenter={true} subtitle={t("social.subtitle")} />
        <div className="social-link-list">
          {data?.map((profile, i) => (
            <a key={i} href={profile.url}>
              {" "}
              <img src={profile.icon} alt="social icon" />{" "}
            </a>
          ))}
        </div>
      </div>
    </SocialStyleWrapper>
  );
};

export default Social;
